import { FC } from "react";
import { Navigate } from "react-router-dom";
import { WithChildren } from "../../_metronic/helpers";
import {
  canAccessPath,
  getDefaultRoute,
  getAuthUser,
  isPortalAdmin,
} from "../../utils/permissions";

type PermissionGuardProps = WithChildren & {
  adminOnly?: boolean;
};

export const PermissionGuard: FC<PermissionGuardProps> = ({
  adminOnly = false,
  children,
}) => {
  const user = getAuthUser();

  if (adminOnly && !isPortalAdmin(user)) {
    return <Navigate to={getDefaultRoute(user)} replace />;
  }

  return <>{children}</>;
};

type VirtualRouteGuardProps = WithChildren & {
  moduleKey: string;
  adminOnly?: boolean;
};

export const VirtualRouteGuard: FC<VirtualRouteGuardProps> = ({
  moduleKey,
  adminOnly = false,
  children,
}) => {
  const user = getAuthUser();

  if (adminOnly && !isPortalAdmin(user)) {
    return <Navigate to={getDefaultRoute(user)} replace />;
  }

  if (user?.isVirtualUser && !user.permissions?.[moduleKey]?.view) {
    return <Navigate to={getDefaultRoute(user)} replace />;
  }

  return <>{children}</>;
};

type PathPermissionGuardProps = WithChildren;

export const PathPermissionGuard: FC<PathPermissionGuardProps> = ({ children }) => {
  const user = getAuthUser();
  const pathname = window.location.pathname;

  if (!canAccessPath(pathname, user)) {
    return <Navigate to={getDefaultRoute(user)} replace />;
  }

  return <>{children}</>;
};
